const getActiveMini = (n, minis) => {
  if (minis.length <= 0) return null;
  const mini = minis.find((m) => m.id === n);
  if (!mini) return null;

  const { gender_taxons, age_range_taxons, ...rest } = mini;
  const facets = [...gender_taxons, ...age_range_taxons];

  return {
    ...rest,
    taxons: facets.map((f) => {
      const category = f.permalink.split('/')[0];
      const value = f.name;

      return { category, value };
    })
  };
};

export default getActiveMini;
